// components/Button.jsx
import React from "react";

const Button = ({
  children,
  bgColor = "#FF7F4A",
  hoverBgColor = "#023F38",
  textColor = "#111827",
  className = "",
  ...props
}) => {
  const baseClasses =
    "inline-flex items-center justify-center border-2 border-black text-2xl md:text-2xl font-semibold px-10 md:px-12 py-4 md:py-5 rounded-2xl transition-all duration-300 ease-in-out transform hover:scale-105 shadow-[6px_6px_0px_0px_black] leading-none text-center";

  const combinedClasses = `${baseClasses} ${className}`;

  return (
    <button
      className={combinedClasses}
      style={{ backgroundColor: bgColor, color: textColor }}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;
